import { useIonRouter } from "@ionic/react";
import { FieldValues, useForm } from "react-hook-form";

import { Button } from "@/components/button";
import { TextAreaInput } from "@/components/inputs/text-area-input";
import { TextInput } from "@/components/inputs/text-input";
import MenuPageLayout from "@/components/layouts/MenuPageLayout";
import { queryClient } from "@/hooks/resources";
import { request } from "@/utils/request";

const InviteClientPage = () => {
  const router = useIonRouter()

  const { handleSubmit, control, setError, formState: { isLoading } } = useForm<FieldValues>({
    defaultValues: {
      recipientName: "",
      recipientEmail: "",
      message: ""
    }
  })

  const onSubmit = async (data: FieldValues) => {
    const response = await request.post("/parent_invitations", data)

    if (response.ok) {
      queryClient.invalidateQueries({ queryKey: ["/invitations"] })

      router.push("/account")
    }
    else {
      if (response.errors) {
        for (const [field, errors] of Object.entries<Array<string>>(
          response.errors,
        )) {
          setError(field, { type: "manual", message: errors.join(", ") + "." });
        }
      }
    }
  }

  return (
    <MenuPageLayout title="Invite Client">
      <form onSubmit={handleSubmit(onSubmit)} className="max-w-screen-md p-4 w-full flex flex-col items-start gap-4">
        <div className="flex flex-col lg:flex-row gap-4 w-full">
          <TextInput
            name="recipientName"
            label="Recipient Name"
            control={control}
            required
            hint="An invitation email will be addressed to this person."
          />

          <TextInput
            name="recipientEmail"
            type="email"
            label="Recipient Email"
            control={control}
            required
            hint="An invitation email will be sent to this email address."
          />
        </div>

        <TextAreaInput
          name="message"
          label="Message"
          control={control}
          required
          hint="Your client will see this message in the invitation email."
        />

        <Button type="submit" className="btn-secondary px-12 mx-auto" loading={isLoading}>
          Send Invitation
        </Button>
      </form>
    </MenuPageLayout>
  );
};

export default InviteClientPage;
